import React, { useEffect, useState } from 'react';
import ProxyPicker from './ProxyPicker';
import { Grid } from '../../ecosystem';
const ProxySelection = (props) => {

    return <Grid fluid className= "body-content body-content--no-top-offset proxy-picker-container">
        <ProxyPicker />
    </Grid>;
}

export default ProxySelection;
